/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-wrapper-object-types */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ComponentState, ZXComponent } from 'src/app/models/component';
import { SolutionSpace } from '../../models/solution';
import {
  BackendComponentActivity,
  BackendComponentActivityDescription,
} from 'src/app/models/backend/backend-component-activity';
import { environment } from 'src/environments/environment';
import { ComponentHealth } from 'src/app/models/component-health';
import { HistoricalUtilStatistic } from 'src/app/models/historicalUtilStatistic';
import { Country, CountryLocations, LocationInfo, LocationType } from 'src/app/models/locations';
import { isDefined } from 'src/app/shared/utils';
import { UserService } from './user.service';
import { PageRequest, ComponentsSortOrder } from 'src/app/models/page-request';
import { PageResponse } from 'src/app/models/page-response';
import { plainToClass } from 'class-transformer';

export enum positionType {
  GNSS,
  BASE_STATION,
}
export class BackendComponent {
  id: string;
  name: string;
  groupName: string;
  groupId: string;
  projectId: string;
  projectName: string;
  projectDescription: string;
  isCurrentlyInProject: boolean;
  componentTypeId: string;
  componentTypeName: string;
  componentTypeDescription: string;
  deviceId: string;
  deviceIdentifier: string;
  deviceType: string;
  position: { lat: number; lng: number; type: positionType };
  archived: boolean;
  componentHealth: ComponentHealth;
  state: ComponentState;
  lastBatteryChangedAt?: Date;
  lastInspectedAt?: Date;

  lastKnownCountryId: string;
  lastKnownCountryName: string;
  lastKnownRegionId: string;
  lastKnownRegionName: string;
  lastKnownPlaceId: string;
  lastKnownPlaceName: string;
  lastKnownPostcodeId: string;
  lastKnownPostcodeName: string;

  cycles: number;
  currentCycleDaysAvailable: number;
  currentCycleDaysInUse: number;
  currentCycleDaysInReturn: number;
  currentCycleDaysInService: number;
}

export class BackendCreateComponent {
  solution?: string;
  group?: string;
  name?: string;
  type?: string;
  devices: { id: string; identifier: string }[];
  description?: string;
}

export class BackendUpdateComponent {
  name?: string;
  type?: string;
  description?: string;
}
export class ComponentInspectRequest {
  inspectedAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class ComponentsService {
  componentsUrl: string;

  constructor(private http: HttpClient, userService: UserService) {
    this.componentsUrl = environment.api + `/api/${userService.getOrganisationId()}/component/`;
  }

  get apiUrl(): string {
    return environment.api + `/api/`;
  }

  getComponent(solutionSpace: SolutionSpace, componentId: string): Observable<ZXComponent> {
    return this.http
      .get<ZXComponent>(`${this.componentsUrl}${solutionSpace}/${componentId}`)
      .pipe(map((component) => plainToClass(ZXComponent, component)));
  }

  getComponentActivity(
    componentId: string,
    limit?: number,
    descriptions?: Array<BackendComponentActivityDescription>
  ): Observable<BackendComponentActivity[]> {
    let params = new HttpParams();
    if (limit !== undefined) {
      params = params.set('limit', limit.toString());
    }
    if (descriptions !== undefined) {
      descriptions.forEach((desc) => {
        params = params.append('descriptions', desc);
      });
    }
    return this.http
      .get<BackendComponentActivity[]>(`${this.componentsUrl}${componentId}/activity?${params.toString()}`)
      .pipe(map((activities) => activities.map((activity) => plainToClass(BackendComponentActivity, activity))));
  }

  createComponent(componentCreate: BackendCreateComponent): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(this.componentsUrl, componentCreate);
    // eslint-disable-next-line @typescript-eslint/unbound-method
  }

  updateComponent(componentId: string, componentUpdate: BackendUpdateComponent): Observable<{ id: string }> {
    return this.http.put<{ id: string }>(`${this.componentsUrl}${componentId}`, componentUpdate);
  }

  archiveComponent(id: string): Observable<HttpErrorResponse> {
    return this.http.post<HttpErrorResponse>(`${this.componentsUrl}${id}/archive`, {});
  }

  archiveComponents(
    componentIds: string[]
    // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
  ): Observable<Object> {
    return this.http.post(`${this.componentsUrl}ArchiveMultiple`, componentIds);
  }

  getLocations(filter: string): Observable<LocationInfo[]> {
    let params = new HttpParams();
    if (filter !== undefined) {
      params = params.set('nameContains', filter);
    }

    return this.http
      .get<CountryLocations>(`${this.apiUrl}Location?${params.toString()}`)
      .pipe(map((countryLocation) => this.flatMapToLocationInfo(countryLocation.countries)));
  }

  getComponents(
    solutionSpace: SolutionSpace,
    options: {
      states?: Array<ComponentState>;
      pageRequest?: PageRequest<ComponentsSortOrder>;
      likeSearch?: string;
      projectIds?: Array<string>;
      componentTypeIds?: Array<string>;
      isPositioned?: boolean;
      currentCycleAvailableDaysGTE?: number;
      currentCycleAvailableDaysLTE?: number;
      currentCycleInUseDaysGTE?: number;
      currentCycleInUseDaysLTE?: number;
      currentCycleInReturnDaysGTE?: number;
      currentCycleInReturnDaysLTE?: number;
      currentCycleInServiceDaysGTE?: number;
      currentCycleInServiceDaysLTE?: number;
      countryIds?: Array<string>;
      regionIds?: Array<string>;
      placeIds?: Array<string>;
      postcodeIds?: Array<string>;
      lastCommunicationTimeFrom?: string;
      lastCommunicationTimeTo?: string;
      // for just humidity devices
      latestExternalHumidityMeasurementValueGTE?: number;
      latestExternalHumidityMeasurementValueLTE?: number;
      latestExternalTemperatureMeasurementValueGTE?: number;
      latestExternalTemperatureMeasurementValueLTE?: number;
      minLat?: number;
      maxLat?: number;
      minLon?: number;
      maxLon?: number;
      geofenceIds?: Array<string>;
    }
  ): Observable<PageResponse<BackendComponent>> {
    let params = new HttpParams();
    if (options.likeSearch !== undefined && options.likeSearch !== '') {
      params = params.set('likeSearch', options.likeSearch);
    }
    if (options.states !== undefined) {
      options.states.forEach((state) => {
        params = params.append('states', state);
      });
    }
    if (options.pageRequest?.sortDirection !== undefined) {
      params = params.set('sortDirection', options.pageRequest.sortDirection.toString());
    }
    if (options.pageRequest?.sortOrder !== undefined) {
      params = params.set('sortOrder', options.pageRequest.sortOrder.toString());
    }

    if (options.pageRequest?.pageNumber !== undefined) {
      params = params.set('pageNumber', options.pageRequest.pageNumber.toString());
    }
    if (options.pageRequest?.pageSize !== undefined) {
      params = params.set('pageSize', options.pageRequest.pageSize.toString());
    }
    if (options.projectIds !== undefined) {
      options.projectIds.forEach((id) => {
        params = params.append('projectIds', id);
      });
    }
    if (options.componentTypeIds !== undefined) {
      options.componentTypeIds.forEach((id) => {
        params = params.append('componentTypeIds', id);
      });
    }
    if (options.isPositioned !== undefined) {
      params = params.set('isPositioned', options.isPositioned.toString());
    }

    if (
      isDefined(options.minLat) &&
      isDefined(options.maxLat) &&
      isDefined(options.minLon) &&
      isDefined(options.maxLon)
    ) {
      params = params.set('minLat', options.minLat);
      params = params.set('maxLat', options.maxLat);
      params = params.set('minLon', options.minLon);
      params = params.set('maxLon', options.maxLon);
    }

    // for  Utilization devices
    if (solutionSpace === SolutionSpace.Utilization) {
      if (options.currentCycleAvailableDaysGTE !== undefined) {
        params = params.set('currentCycleAvailableDaysGTE', options.currentCycleAvailableDaysGTE.toString());
      }

      if (options.currentCycleAvailableDaysLTE !== undefined) {
        params = params.set('currentCycleAvailableDaysLTE', options.currentCycleAvailableDaysLTE.toString());
      }
      if (options.currentCycleInUseDaysGTE !== undefined) {
        params = params.set('currentCycleInUseDaysGTE', options.currentCycleInUseDaysGTE.toString());
      }
      if (options.currentCycleInUseDaysLTE !== undefined) {
        params = params.set('currentCycleInUseDaysLTE', options.currentCycleInUseDaysLTE.toString());
      }
      if (options.currentCycleInReturnDaysGTE !== undefined) {
        params = params.set('currentCycleInReturnDaysGTE', options.currentCycleInReturnDaysGTE.toString());
      }
      if (options.currentCycleInReturnDaysLTE !== undefined) {
        params = params.set('currentCycleInReturnDaysLTE', options.currentCycleInReturnDaysLTE.toString());
      }
      if (options.currentCycleInServiceDaysGTE !== undefined) {
        params = params.set('currentCycleInServiceDaysGTE', options.currentCycleInServiceDaysGTE.toString());
      }
      if (options.currentCycleInServiceDaysLTE !== undefined) {
        params = params.set('currentCycleInServiceDaysLTE', options.currentCycleInServiceDaysLTE.toString());
      }
    }
    if (solutionSpace === SolutionSpace.Humidity) {
      if (options.latestExternalHumidityMeasurementValueGTE !== undefined) {
        params = params.set(
          'latestExternalHumidityMeasurementValueGTE',
          options.latestExternalHumidityMeasurementValueGTE.toString()
        );
      }
      if (options.latestExternalHumidityMeasurementValueLTE !== undefined) {
        params = params.set(
          'latestExternalHumidityMeasurementValueLTE',
          options.latestExternalHumidityMeasurementValueLTE.toString()
        );
      }
      if (options.latestExternalTemperatureMeasurementValueGTE !== undefined) {
        params = params.set(
          'latestExternalTemperatureMeasurementValueGTE',
          options.latestExternalTemperatureMeasurementValueGTE.toString()
        );
      }
      if (options.latestExternalTemperatureMeasurementValueLTE !== undefined) {
        params = params.set(
          'latestExternalTemperatureMeasurementValueLTE',
          options.latestExternalTemperatureMeasurementValueLTE.toString()
        );
      }
    }

    if (options.countryIds !== undefined) {
      options.countryIds.forEach((state) => {
        params = params.append('countryIds', state);
      });
    }
    if (options.regionIds !== undefined) {
      options.regionIds.forEach((state) => {
        params = params.append('regionIds', state);
      });
    }
    if (options.placeIds !== undefined) {
      options.placeIds.forEach((state) => {
        params = params.append('placeIds', state);
      });
    }
    if (options.postcodeIds !== undefined) {
      options.postcodeIds.forEach((state) => {
        params = params.append('postcodeIds', state);
      });
    }
    if (options.lastCommunicationTimeFrom !== undefined) {
      params = params.set('lastCommunicationTimeFrom', options.lastCommunicationTimeFrom);
    }
    if (options.lastCommunicationTimeTo !== undefined) {
      params = params.set('lastCommunicationTimeTo', options.lastCommunicationTimeTo);
    }
    if (options.geofenceIds !== undefined) {
      options.geofenceIds.forEach((id) => {
        params = params.append('geofenceIds', id);
      });
    }

    return this.http
      .get<PageResponse<BackendComponent>>(`${this.componentsUrl}${solutionSpace}?${params.toString()}`)
      .pipe(
        map((list: PageResponse<BackendComponent>) => {
          return {
            items: list.items.map((c) => {
              return {
                id: c.id,
                name: c.name,
                groupName: c.groupName,
                groupId: c.groupId,
                projectName: c.projectName,
                projectId: c.projectId,
                projectDescription: c.projectDescription,
                isCurrentlyInProject: c.isCurrentlyInProject,
                componentTypeId: c.componentTypeId,
                componentTypeDescription: c.componentTypeDescription,
                componentTypeName: c.componentTypeName,
                deviceId: c.deviceId,
                deviceIdentifier: c.deviceIdentifier, // not provided by backend
                deviceType: c.deviceType, // not provided by backend
                position: c.position,
                archived: c.archived,
                componentHealth: c.componentHealth,
                state: c.state,
                cycles: c.cycles,
                currentCycleDaysAvailable: c.currentCycleDaysAvailable,
                currentCycleDaysInUse: c.currentCycleDaysInUse,
                currentCycleDaysInReturn: c.currentCycleDaysInReturn,
                currentCycleDaysInService: c.currentCycleDaysInService,
                lastKnownCountryId: c.lastKnownCountryId,
                lastKnownCountryName: c.lastKnownCountryName,
                lastKnownRegionId: c.lastKnownRegionId,
                lastKnownRegionName: c.lastKnownRegionName,
                lastKnownPlaceId: c.lastKnownPlaceId,
                lastKnownPlaceName: c.lastKnownPlaceName,
                lastKnownPostcodeId: c.lastKnownPostcodeId,
                lastKnownPostcodeName: c.lastKnownPostcodeName,
              };
            }),
            totalItemCount: list.totalItemCount,
            pageCount: list.pageCount,
            hasNextPage: list.hasNextPage,
            hasPreviousPage: list.hasPreviousPage,
          };
        })
      );
  }

  getUtilStatistics(componentId: string): Observable<HistoricalUtilStatistic> {
    return this.http.get<HistoricalUtilStatistic>(`${this.componentsUrl}${componentId}/statistics`);
  }

  receivedInService(componentId: string) {
    return this.http.post(`${this.componentsUrl}${componentId}/ReceiveInService`, {});
  }

  ReleaseFromService(componentId: string) {
    return this.http.post(`${this.componentsUrl}${componentId}/ReleaseFromService`, {});
  }

  inspect(componentId: string, date: Date): Observable<any> {
    var componentInspectRequest: ComponentInspectRequest = { inspectedAt: date.toISOString() };
    return this.http.post(`${this.componentsUrl}${componentId}/Inspect`, componentInspectRequest);
  }

  unlinkDevice(componentId: string) {
    return this.http.put(`${this.componentsUrl}${componentId}/unlink-device`, {});
  }

  linkDevice(componentId: string, deviceId: string) {
    return this.http.put(`${this.componentsUrl}${componentId}/link-device/${deviceId}`, {});
  }

  private flatMapToLocationInfo(countries: Country[]): LocationInfo[] {
    const flattenLocations = countries.flatMap((country) => {
      const mappedCountries = this.mapToLocationInfo(country.id, country.name, LocationType.COUNTRY);
      const flattenRegionLoc = country.regions.flatMap((region) => {
        const mappedRegion = this.mapToLocationInfo(region.id, region.name, LocationType.REGION);
        const flattenPlaceLoc = region.places.flatMap((place) => {
          const mappedPlaces = this.mapToLocationInfo(place.id, place.name, LocationType.PLACE);
          const flattenPostcodeLoc = place.postcodes.flatMap((postcode) => {
            return this.mapToLocationInfo(postcode.id, postcode.name, LocationType.POSTCODE);
          });

          return [mappedPlaces, ...flattenPostcodeLoc];
        });

        return [mappedRegion, ...flattenPlaceLoc];
      });

      return [mappedCountries, ...flattenRegionLoc];
    });
    return flattenLocations;
  }

  private mapToLocationInfo(id: string, name: string, type: LocationType): LocationInfo {
    return {
      id: id,
      name: name,
      type: type,
    };
  }
}
